import React from "react";
import { useDispatch } from "react-redux";
import { deleteProductData, deleteLineItemData } from "store/programBuilder/actionCreator";
import Modal from "common/modal";
import { api } from "store/slices/api";
import { toast } from "react-toastify";

const DeleteLineModal = ({ setIsModalOpen, itemToDelete }) => {
  const { id, deleteTarget, storeNumber, marketName, productId, lineItemId, categoryName, target } = itemToDelete;

  const dispatch = useDispatch();

  const [deleteMarket] = api.useDeletePbMarketMutation();

  let name = target?.value;
  if (deleteTarget === "market") {
    name = `${storeNumber} - ${marketName}`;
  } else if (deleteTarget === "category") {
    name = categoryName;
  }

  return (
    <Modal
      title={itemToDelete?.deleteTarget === "market" ? "Delete Market" : "Delete Items"}
      saveButtonText="Confirm"
      closeButtonText="Cancel"
      handleSave={async () => {
        setIsModalOpen(false);
        if (deleteTarget === "market") {
          await deleteMarket(id);
        } else {
          const id = deleteTarget === "category" ? productId : lineItemId;
          await dispatch(deleteTarget === "category" ? deleteProductData(id) : deleteLineItemData(id));
        }
        toast.success(`${name} deleted successfully!`);
      }}
      handleCancel={() => setIsModalOpen(false)}
      size="lg"
    >
      Are you sure you want to delete {name}?
      {deleteTarget === "category" ? " Doing so will delete all line items under it as well." : ""}
    </Modal>
  );
};

export default DeleteLineModal;
